import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { resolvePath, welcome } from '../../routes';
import { ReactComponent as IllustrationMaintenance } from './IllustrationMaintenance.svg';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 'bold',
    margin: theme.spacing(2),
    fontSize: theme.spacing(2.5),
  },
  message: {
    fontSize: theme.spacing(2),
  },
  center: {
    textAlign: 'center',
  },
  root: {
    marginTop: theme.spacing(10),
  },
  goToOrg: {
    marginTop: theme.spacing(2),
  },
}));

const MaintenanceProcess = () => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="center" className={classes.root}>
      <Grid item className={classes.center}>
        <IllustrationMaintenance />
        <Typography className={classes.title}>
          <FormattedMessage id="maintenance.page.title" />
        </Typography>
        <Typography className={classes.message}>
          <FormattedMessage id="maintenance.page.message" values={{ br: <br /> }} />
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.goToOrg}
          component={RouterLink}
          to={resolvePath(welcome, undefined, {}, false)}
        >
          <FormattedMessage id="maintenance.page.go.to.welcome.page" />
        </Button>
      </Grid>
    </Grid>
  );
};

export default MaintenanceProcess;
